<template>
  <VForms
    :initial-values="form"
    :validation-schema="validations"
    @submit="handleSubmit"
  >
    <template slot-scope="props">
      <form
        class="register-form"
        @submit.prevent="props.handleSubmit"
      >
        <v-layout column>
          <VTextField
            v-model="props.values.email"
            :error-messages="getEmailErrors(props.errors.email)"
            label="E-mail"
          />
          <VTextField
            v-model="props.values.password"
            :error-messages="getPasswordErrors(props.errors.password)"
            :label="$t('register.password')"
            type="password"
          />
          <VTextField
            v-model="props.values.repeatPassword"
            :error-messages="getRepeatPasswordErrors(props.errors.repeatPassword)"
            :label="$t('register.repeatPassword')"
            type="password"
          />
          <v-checkbox
            v-model="props.values.acceptRules"
            color="secondary"
            :label="$t('register.acceptRules')"
          >
            <template v-slot:label>
              <div class="caption">
                {{ $t('register.acceptRules') }}
                <a
                  target="_blank"
                  href="http://animalki.eu/policy"
                  @click.stop
                >
                  {{ $t('register.termsOfUse') }}
                </a>
              </div>
            </template>
          </v-checkbox>
          <v-layout
            row
            wrap
            justify-center
          >
            <VBtn
              color="primary"
              outline
              @click="$router.push({ name: 'LoginPage' })"
            >
              {{ $t('button.return') }}
            </VBtn>
            <VBtn
              color="primary"
              :loading="props.isSubmitting"
              :disabled="!props.values.acceptRules"
              type="submit"
            >
              {{ $t('register.register') }}
            </VBtn>
          </v-layout>
        </v-layout>
      </form>
    </template>
  </VForms>
</template>

<script>
import { Form as VForms } from '@v-forms/core'
import { mapActions } from 'vuex'
import {
  required,
  email,
  sameAs,
  minLength,
  maxLength,
} from 'vuelidate/lib/validators'
import { ACTION_REGISTER } from '../store/types/user.types'

export default {
  name: 'RegisterForm',
  components: {
    VForms,
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
        repeatPassword: '',
        acceptRules: false,
      },
      validations: {
        email: {
          required,
          email,
        },
        password: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(16),
        },
        repeatPassword: {
          required,
          sameAsPassword: sameAs('password'),
        },
      },
    }
  },
  methods: {
    async handleSubmit(values, actions) {
      this.register(values)
      actions.setSubmitting(false)
    },
    getEmailErrors(values = {}) {
      const errors = []
      if (values.required) errors.push(this.$t('validates.requiredField'))
      if (values.email) errors.push(this.$t('validates.emailNotValid'))
      return errors
    },
    getPasswordErrors(values = {}) {
      const errors = []
      if (values.required) errors.push(this.$t('validates.requiredField'))
      if (values.minLength || values.maxLength) errors.push(this.$t('validates.passwordLength'))
      return errors
    },
    getRepeatPasswordErrors(values = {}) {
      const errors = []
      if (values.required) errors.push(this.$t('validates.requiredField'))
      if (values.sameAsPassword) errors.push(this.$t('validates.repeatPassword'))
      return errors
    },
    ...mapActions({
      register: ACTION_REGISTER,
    }),
  },
}
</script>

<style lang="stylus" scoped>
a {
  color: var(--v-secondary-base)
}


@media only screen and (min-width: 480px) {
  .register-form {
    width: 30em;
  }
}

@media only screen and (max-width: 480px) {
  .register-form {
    padding: 0 2em;
    width: 100%;
  }
  button {
    width: 100%;
  }
}
</style>
